"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = require("invariant");

var _invariant2 = _interopRequireDefault(_invariant);

var _getContext = require("./getContext");

var _getContext2 = _interopRequireDefault(_getContext);

var _loseGL = require("./loseGL");

var _loseGL2 = _interopRequireDefault(_loseGL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __DEV__ = process.env.NODE_ENV === "development";

/**
 * WebGL context initial options.
 */


var propTypes = {
  onContextCreate: _propTypes2.default.func.isRequired,
  onContextFailure: _propTypes2.default.func.isRequired,
  onContextLost: _propTypes2.default.func.isRequired,
  onContextRestored: _propTypes2.default.func.isRequired,
  webglContextAttributes: _propTypes2.default.object,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,
  style: _propTypes2.default.object,
  pixelRatio: _propTypes2.default.number
};

var ErrorDebug = function (_Component) {
  _inherits(ErrorDebug, _Component);

  function ErrorDebug() {
    _classCallCheck(this, ErrorDebug);

    return _possibleConstructorReturn(this, (ErrorDebug.__proto__ || Object.getPrototypeOf(ErrorDebug)).apply(this, arguments));
  }

  _createClass(ErrorDebug, [{
    key: "render",
    value: function render() {
      var error = this.props.error;

      var title = String(error.rawError || error.message || error);
      var detail = String(error.longMessage || error.rawError || "");
      var style = {
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        padding: "1em",
        background: "#a00",
        color: "#fff",
        fontSize: "12px",
        lineHeight: "1.2em",
        fontStyle: "normal",
        fontWeight: "normal",
        fontFamily: "monospace",
        overflow: "auto"
      };
      var titleStyle = {
        fontWeight: "bold",
        marginBottom: "1em"
      };
      var detailStyle = {
        whiteSpace: "pre"
      };
      return _react2.default.createElement(
        "div",
        { style: style },
        _react2.default.createElement(
          "div",
          { style: titleStyle },
          title
        ),
        _react2.default.createElement(
          "div",
          { style: detailStyle },
          detail
        )
      );
    }
  }]);

  return ErrorDebug;
}(_react.Component);

var GLViewDOM = function (_Component2) {
  _inherits(GLViewDOM, _Component2);

  function GLViewDOM() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, GLViewDOM);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = GLViewDOM.__proto__ || Object.getPrototypeOf(GLViewDOM)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      error: null
    }, _this2._onContextLost = function (e) {
      e.preventDefault();
      _this2.gl = null;
      _this2.props.onContextLost();
    }, _this2._onContextRestored = function () {
      _this2.gl = _this2._createContext();
      _this2.props.onContextRestored(_this2.gl);
    }, _this2.onRef = function (ref) {
      _this2.canvas = ref;
    }, _this2.debugError = !__DEV__ ? null : function (error) {
      _this2.setState({ error: error });
    }, _this2.afterDraw = !__DEV__ ? null : function () {
      if (_this2.state.error) {
        _this2.setState({ error: null });
      }
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(GLViewDOM, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          onContextCreate = _props.onContextCreate,
          onContextFailure = _props.onContextFailure;

      var gl = this._createContext();
      if (gl) {
        this.gl = gl;
        onContextCreate(gl);
        var canvas = this.canvas;

        (0, _invariant2.default)(canvas, "canvas is not settled in GLViewDOM#componentDidMount");
        canvas.addEventListener("webglcontextlost", this._onContextLost);
        canvas.addEventListener("webglcontextrestored", this._onContextRestored);
      } else {
        onContextFailure(new Error("no-webgl-context"));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.gl) {
        (0, _loseGL2.default)(this.gl);
        this.gl = null;
      }
      var canvas = this.canvas;

      if (canvas) {
        canvas.removeEventListener("webglcontextlost", this._onContextLost);
        canvas.removeEventListener("webglcontextrestored", this._onContextRestored);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var error = this.state.error;

      var _props2 = this.props,
          width = _props2.width,
          height = _props2.height,
          pixelRatio = _props2.pixelRatio,
          style = _props2.style,
          debug = _props2.debug,
          rest = _objectWithoutProperties(_props2, ["width", "height", "pixelRatio", "style", "debug"]);

      if (!pixelRatio) pixelRatio = Number((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && window.devicePixelRatio || 1);
      for (var k in propTypes) {
        if (rest.hasOwnProperty(k)) {
          delete rest[k];
        }
      }
      return _react2.default.createElement(
        "span",
        {
          style: _extends({}, style, {
            display: "inline-block",
            position: "relative",
            width: width,
            height: height
          })
        },
        _react2.default.createElement("canvas", _extends({
          ref: this.onRef,
          style: { width: width, height: height },
          width: width * pixelRatio,
          height: height * pixelRatio
        }, rest)),
        error ? _react2.default.createElement(ErrorDebug, { error: error }) : null
      );
    }
  }, {
    key: "_createContext",
    value: function _createContext() {
      var _props3 = this.props,
          webglContextAttributes = _props3.webglContextAttributes,
          debug = _props3.debug;

      var gl = (0, _getContext2.default)(this.canvas, debug ? _extends({}, webglContextAttributes, { preserveDrawingBuffer: true }) : webglContextAttributes);
      this.webglContextAttributes = webglContextAttributes || {};
      return gl;
    }
  }, {
    key: "captureAsDataURL",
    value: function captureAsDataURL() {
      var _canvas;

      if (!this.webglContextAttributes.preserveDrawingBuffer) {
        console.warn("Surface#captureAsDataURL is likely to not work if you don't define webglContextAttributes={{ preserveDrawingBuffer: true }}");
      }
      (0, _invariant2.default)(this.canvas, "canvas is no longer available");
      return (_canvas = this.canvas).toDataURL.apply(_canvas, arguments);
    }
  }, {
    key: "captureAsBlob",
    value: function captureAsBlob() {
      var _this3 = this;

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      if (!this.webglContextAttributes.preserveDrawingBuffer) {
        console.warn("Surface#captureAsBlob is likely to not work if you don't define webglContextAttributes={{ preserveDrawingBuffer: true }}");
      }
      return Promise.resolve().then(function () {
        return new Promise(function (resolve, reject) {
          var _canvas2;

          return _this3.canvas ? (_canvas2 = _this3.canvas).toBlob.apply(_canvas2, [resolve].concat(_toConsumableArray(args))) : reject(new Error("canvas is no longer available"));
        });
      });
    }
  }]);

  return GLViewDOM;
}(_react.Component);

GLViewDOM.propTypes = propTypes;
exports.default = GLViewDOM;
//# sourceMappingURL=GLViewDOM.js.map


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/gl-react-dom/lib/GLViewDOM.js
// module id = 927
// module chunks = 0